import React, { FC } from 'react';
import { Box } from '@chakra-ui/react';

import { RequiredMarkItemLabel } from '../atom/label/RequiredMarkItemLabel';

type ComponentsWithLabelProps = {
  label: string;
  children: React.ReactNode;
  noticed?: boolean;
  chkValue?: boolean;
};

export const ComponentsWithLabel: FC<ComponentsWithLabelProps> = (
  props: ComponentsWithLabelProps
) => {
  const { label, children, noticed = true, chkValue = false } = props;

  return (
    <Box mb={5}>
      <RequiredMarkItemLabel
        label={label}
        noticed={noticed}
        chkValue={chkValue}
      />
      {children}
    </Box>
  );
};
